import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
//import { CommonGetApi } from '../axiosComponent/read';
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";

const MyBranch = ({
    field: { name, value, dataId },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const errorText = touched[name] && errors[name];
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        // $("#searchType .dropdown").removeClass("dropdown")
        setloading(true)
        allAxiosCommonRequest({
            url: "branch",
            method: "get",
          })//CommonGetApi({ url: 'branch' })
          .then((response) => {
            setcontent(response)
            setloading(false)
        }).catch((error) => console.log(error))
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.branchId
            temp.text = `${object.branchName} (${object.branchCode})`
            temp.value = name == 'branchCode' ? object.branchCode : { code: object.branchCode, name: object.branchName }
            temp.extra = object
            return options[index] = temp
        })
    }

    let handleChange = (value, data) => {
        if (name == 'branchCode') {
            setFieldValue(name, data.value)
            let singleObject = data.options.filter((args => args.extra.branchCode == data.value))
            setFieldValue(props.extra, singleObject[0].extra)
            setFieldValue(props.address, singleObject[0].extra.address != null ? singleObject[0].extra.address : '')
        } else {
            setFieldValue(name, data.value)
        }

    }

    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"            
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyBranch